import { wwtkReducer } from '../helpers';

/**
 * Action constants
 */
const SET_WWTK_DATA = 'SET_WWTK_DATA';
const SET_DONE_WWTK_ITEM = 'SET_DONE_WWTK_ITEM';

/**
 * Action creators
 */
const actions = {
  setWwtkData: (data) => ({ type: SET_WWTK_DATA, data }),
  setWwtkDoneItem: (data) => ({ type: SET_DONE_WWTK_ITEM, data })
};

const setWwtkData = (wwtkData) => async (dispatch) => {
  try {
    const data = Object
      .keys(wwtkData)
      .reduce((prev, district) => {
        const newItem = prev;
        newItem[district] = wwtkReducer(wwtkData[district]);
        return newItem;
      }, {});
    dispatch(actions.setWwtkData(data));
  } catch (e) {
    dispatch(actions.setWwtkData([]));
    throw new Error(e);
  }
};

const setWwtkDoneItem = (id) => (dispatch) => dispatch(actions.setWwtkDoneItem(id));

export {
  setWwtkData as default,
  setWwtkDoneItem
};
